import { render, staticRenderFns } from "./Consumption1.vue?vue&type=template&id=03048cbe&scoped=true"
import script from "./Consumption1.vue?vue&type=script&lang=js"
export * from "./Consumption1.vue?vue&type=script&lang=js"
import style0 from "./Consumption1.vue?vue&type=style&index=0&id=03048cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03048cbe",
  null
  
)

export default component.exports